import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { of, from } from 'rxjs';
import * as debug from '../../../shared/services/debug.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { MenuService } from 'src/app/shared/services/menu.service';
import { appUrl } from 'src/environments/environment';
import { switchMap, catchError } from 'rxjs/operators';
import { IUserProfile } from 'src/app/shared/responses/iuser-profile';
import { ProfileDbService } from 'src/app/shared/services/profile-db.service';
import { HttpClient } from '@angular/common/http';
import { GlobalErrorHandler } from 'src/app/shared/utils/global-errorhandler';
import { PersistentDbService } from 'src/app/shared/services/persistent-db.service';

@Component({
	selector: 'app-signin-redirect-callback',
	templateUrl: './signin-redirect-callback.component.html',
	styleUrls: ['./signin-redirect-callback.component.scss']
})
export class SigninRedirectCallbackComponent implements OnInit {

	appUrl = appUrl;
	message = 'Preparing user profile..';
	constructor(protected readonly menuService: MenuService
		, private router: Router
		, private readonly httpClient: HttpClient
		, protected readonly securityService: SecurityService
		, protected readonly profileDbService: ProfileDbService
		, protected readonly globalErrorHandler: GlobalErrorHandler
		, protected readonly persistentDbService: PersistentDbService
	) { }

	// scenario 1 - login then subscribe
	async ngOnInit() {
		debug.log(`067 SigninRedirectCallbackComponent ngOnInit`);
		this.message = `Preparing user profile..`;

		let hasError = false;
		let isProfileActive = false;

		const completeLogin = this.securityService.completeLogin();

		let tmpUser = {};

		from(completeLogin)
			.pipe(
				// todo: check if users exists, use the existing profile with with additional flag : is duplicate, sub. let route gurad do the handling
				switchMap(user => {
					tmpUser = user;
					return this.httpClient.put<IUserProfile>(appUrl.userProfile, user);
				})
				, switchMap(profile => {
					this.message = `Saving user profile..`;
					return from(this.securityService.setUserProfile(profile, `067.1 SigninRedirectCallbackComponent`));
				})
				, switchMap(profile => {
					isProfileActive = profile.isActive;
					return of(profile);
				})
				, catchError(error => {
					debug.error(`022 SigninRedirectCallbackComponent catchError. Returning fallbackMenu`, error);
					hasError = true;
					return this.globalErrorHandler.handleError(error);
				})
			)
			.subscribe(async (profile) => {
				if (hasError) {
					this.securityService.logout();
				} else {

					await this.persistentDbService.clearAll();
					if (isProfileActive) {
						debug.log(`068.1 SigninRedirectCallbackComponent ngOnInit isProfileActive redirecting to parcels..`);
						this.router.navigate(['/trackinator/parcels'], { replaceUrl: true });
					} else {
						debug.log(`068.2 SigninRedirectCallbackComponent ngOnInit not isProfileActive redirecting to pricing..`);
						this.router.navigate(['/pricing'], { replaceUrl: true });
					}
				}
			});
	}
}
